import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'db0011',
    ecrans: ['00-2'],
    params: ['id']
});
